import React, { useState, useEffect } from "react";
import classes from "./CustomPagination.module.scss";
import PersianPrice from "../../components/PersianPrice/PersianPrice";
import useWindowSize from "../../hooks/useWindowsSize";
import { useTranslation } from "react-i18next";

export default function CustomPagination({ setRowsPerPage }) {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState(5);
  const windowSize = useWindowSize();

  function handleClick(value) {
    setRowsPerPage(() => setRowsPerPage(value));
    setActive(value);
  }

  useEffect(() => {
    if (windowSize?.height > 750) {
      setRowsPerPage(() => setRowsPerPage(10));
      setActive(10);
    } else {
      setRowsPerPage(() => setRowsPerPage(5));
      setActive(5);
    }
  }, [windowSize?.height]);

  return (
    <div className={windowSize.width > 430 ? classes.root : classes.mobileRoot}>
      <ul className={classes.list}>
        <li
          className={active === 5 ? classes.activeClass : classes.items}
          onClick={() => handleClick(5)}
        >
          {" "}
          {i18n.language === "fa" ? <PersianPrice number={5} /> : 5}{" "}
        </li>
        <li
          className={active === 10 ? classes.activeClass : classes.items}
          onClick={() => handleClick(10)}
        >
          {" "}
          {i18n.language === "fa" ? <PersianPrice number={10} /> : 10}
        </li>
        <li
          className={active === 20 ? classes.activeClass : classes.items}
          onClick={() => handleClick(20)}
        >
          {" "}
          {i18n.language === "fa" ? <PersianPrice number={20} /> : 20}
        </li>
        <li
          className={active === 30 ? classes.activeClass : classes.items}
          onClick={() => handleClick(30)}
        >
          {" "}
          {i18n.language === "fa" ? <PersianPrice number={30} /> : 30}
        </li>
        <li
          className={active === -1 ? classes.activeClass : classes.items}
          onClick={() => handleClick(-1)}
        >
          {t("pagination.all")}
        </li>
      </ul>
    </div>
  );
}
